import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageDeLite() {
    return (
        <div className="privacy-policy-container">
<h1>Datenschutzrichtlinie von Tasbih Dhikr Lite</h1>
      <p>Letzte Aktualisierung: 31. Januar 2024</p>

      <h2>Einführung</h2>
      <p>Willkommen bei der App Tasbih Dhikr Lite. Diese Datenschutzrichtlinie soll Sie darüber informieren, wie wir Ihre Daten verarbeiten, wenn Sie unsere App verwenden. Die einzige Datenerhebung in dieser App erfolgt durch AdMob, einen Werbedienst von Google, und wir sammeln aktiv keine persönlichen Daten.</p>

      <h2>1. Sammlung und Verwendung Ihrer persönlichen Daten</h2>
      <h3>a. Arten von gesammelten Daten</h3>
      <h4>i. Datennutzung über AdMob</h4>
      <p>Unsere App verwendet AdMob, um Werbung anzuzeigen. AdMob kann Daten wie Ihre IP-Adresse, Ihre Geräte-ID und Informationen über Ihre Nutzung der App sammeln. Diese Informationen werden verwendet, um die Werbeerfahrung zu verbessern und zu personalisieren.</p>

      <h3>b. Verwendung der Daten</h3>
      <p>Die von AdMob gesammelten Daten werden verwendet für:</p>
      <ul>
        <li>Bereitstellung und Personalisierung von Werbung in der App.</li>
        <li>Analyse der Wirksamkeit der angezeigten Werbung.</li>
      </ul>

      <h3>c. Kontrolle durch den Nutzer</h3>
      <p>Sie können die Verwendung Ihrer Daten für personalisierte Werbung über die Einstellungen Ihres Geräts steuern.</p>

      <h2>2. Übertragung von Daten</h2>
      <p>Ihre Daten können auf Computer übertragen und dort gespeichert werden, die sich außerhalb Ihres Staates, Ihrer Provinz oder Ihres Landes befinden, wo die Datenschutzgesetze abweichen können.</p>

      <h2>3. Offenlegung Ihrer persönlichen Daten</h2>
      <p>Die von AdMob gesammelten Daten können gemäß der Datenschutzrichtlinie von Google und rechtlichen Anforderungen geteilt werden.</p>

      <h2>4. Sicherheit Ihrer persönlichen Daten</h2>
      <p>Die Sicherheit Ihrer Daten ist uns wichtig. Dennoch ist keine Methode der Übertragung über das Internet oder der elektronischen Speicherung 100% sicher.</p>

      <h2>5. Links zu anderen Websites</h2>
      <p>Unser Service kann Links zu anderen Websites enthalten. Wenn Sie auf einen Link eines Drittanbieters klicken, werden Sie auf die Website dieses Dritten weitergeleitet.</p>

      <h2>6. Änderungen dieser Datenschutzrichtlinie</h2>
      <p>Wir können unsere Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Wir werden Sie über Änderungen informieren, indem wir die neue Datenschutzrichtlinie auf dieser Seite veröffentlichen.</p>

      <h2>7. Kontaktieren Sie uns</h2>
      <p>Wenn Sie Fragen zu dieser Datenschutzrichtlinie haben, kontaktieren Sie uns bitte.</p>

      <h2>Nützliche Links</h2>
      <p><a href="https://policies.google.com/privacy">Datenschutzrichtlinie von Google</a></p>
    </div>

    );
}

export default PrivacyPolicyPageDeLite;
